var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";

function IconQuestionHelp(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zM2.25 10a7.75 7.75 0 1115.5 0 7.75 7.75 0 01-15.5 0z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    d: "M9.69 12.17c.46 0 .7-.28.76-.73.06-.62.27-.95 1.17-1.47.93-.55 1.45-1.27 1.45-2.32 0-1.54-1.27-2.6-3.12-2.6-1.41 0-2.48.58-2.9 1.5-.13.27-.2.52-.2.81 0 .46.29.75.76.75.37 0 .63-.17.78-.6.22-.69.72-1.06 1.48-1.06.84 0 1.42.52 1.42 1.26 0 .66-.29 1.04-1.13 1.55-.86.5-1.28 1.06-1.28 1.91v.13c0 .5.29.87.8.87zm0 2.97c.56 0 1-.43 1-.97a.97.97 0 00-1-.97c-.54 0-.99.43-.99.97s.45.97 1 .97z"
  }));
}

export default IconQuestionHelp;